export default "__VITE_ASSET__B2xd9hbp__"